<template>
<div class="msg-notification-setting">
  <el-form ref="editForm" label-width="100px" :model="editJson" :rules="rules">
    <el-form-item label="对象类型" prop="msgObjectType">
      <common-select :disabled="this.isEdit" v-model="editJson.msgObjectType" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'MsgObjectType'}"  ajaxMethod="get" optLabel="itemDesc" optValue="itemValue"></common-select>
    </el-form-item>
    <el-form-item label="动作" prop="msgAction">
      <common-select :disabled="this.isEdit" v-model="editJson.msgAction" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'MsgAction'}"  ajaxMethod="get" optLabel="itemDesc" optValue="itemValue"></common-select>
    </el-form-item>
    <el-form-item label="消息模板" prop="msgTemplate">
      <el-autocomplete v-model="editJson.msgTemplate" :fetch-suggestions="msgTemplateSearch"></el-autocomplete>
      <!-- <common-select v-model="editJson.msgTemplate" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'MsgTemplate'}"  ajaxMethod="get" optLabel="itemDesc" optValue="itemValue"></common-select> -->
    </el-form-item>
    <el-form-item label="提醒方式" prop="notifyMethod">
      <common-select v-model="editJson.notifyMethod" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'NotifyMethod'}"  ajaxMethod="get" optLabel="itemDesc" optValue="itemValue"></common-select>
    </el-form-item>
    <el-form-item label="设置类型" prop="msgSettingType">
      <common-select v-model="editJson.msgSettingType" :url="$api.Identity.BasicData.all" :filterData="filterData" :params="{ItemType:'MsgSettingType'}"  ajaxMethod="get" optLabel="itemDesc" optValue="itemValue"></common-select>
    </el-form-item>
    <el-form-item label="移动链接" prop="mobileUrl">
      <el-input type="textarea" v-model="editJson.mobileUrl"></el-input>
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      <el-input type="textarea" v-model="editJson.remark"></el-input>
    </el-form-item>
    <el-form-item label-width="0" class="atb-no-margin">
    <div class="atb-text-right">
      <!-- 保存 -->
      <el-button class="atb-dialog-confirm" type="primary" @click="submit">保存</el-button>
      <!-- 取消 -->
      <el-button class="atb-dialog-cancel" type="cancel" @click="$parent.$parent.hide();">取消</el-button>
    </div>
  </el-form-item>
  </el-form>
</div>

</template>
<script>
import editMixin from '@/mixins/edit.mixin'
export default {
  mixins: [ editMixin ],
   props: {
    // 编辑信息
    editData: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    return {
      id: 'id',
      rules: {
        msgObjectType: [
          { required: true, message: '请选择对象类型', trigger: 'change' }
        ],
        msgAction: [
          { required: true, message: '请选择动作', trigger: 'change' }
        ],
        msgTemplate: [
          { required: true, message: '请选择消息模板', trigger: 'change' }
        ],
        notifyMethod: [
          { required: true, message: '请选择提醒方式', trigger: 'change' }
        ],
        msgSettingType: [
          { required: true, message: '请选择设置类型', trigger: 'change' }
        ]
      },
      addApi: this.$api.Identity.MsgNotificationSetting.adu,
      editApi: this.$api.Identity.MsgNotificationSetting.adu,
      editMethod:'put',
      depData:[],
      msgTemplateList:[]
    }
  },
  created(){
    if(this.editJson[this.id]){
      this.$set(this.editJson,'notifyMethod', this.editJson['notifyMethod'].toString())
    }  
  },
  mounted(){
      this.getMsgTemplateList();
  },
  methods:{
     filterData(res){
       return res.data&&res.data.rows||[];
     },
     msgTemplateSearch(queryString, cb) {
      let programList = this.msgTemplateList;
      // 调用 callback 返回建议列表的数据
      cb(programList);
     },
     getMsgTemplateList(){
       this.msgTemplateList=[];
         this.$ajax.get(this.$api.common.getDict,{ItemType:'MsgTemplate'}).then((res) => {
           this.msgTemplateList=res.data&&res.data.rows.map(p=>{
              return {value:p.itemValue};
           })||[];
         });
      },
  }
}
</script>
<style scoped lang="scss">
  .msg-notification-setting{
    .el-autocomplete{
      width: 100%;
    }
  }
</style>
